import { render, staticRenderFns } from "./VendorPurchaseInvoices.vue?vue&type=template&id=06d5260a"
import script from "./VendorPurchaseInvoices.vue?vue&type=script&lang=ts"
export * from "./VendorPurchaseInvoices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports